import { fromJS } from 'immutable';

import { ApiDashboard,UserToken } from '../../../helper/HelperAuth'
import {GetDailyMessageByStatus, GetSenderAll} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'


export default (body, type=null) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiDashboard + 'daily-message-by-status';

    var query = body

    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
            'template-type':type,

        },
        body : JSON.stringify(query)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    var responseData = [];
    var finalData = [];
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('daily-message-by-status');
        for (var i = 0; i < data.size; i++) {
            responseData = []
            let dataDetail = data.get(i)
            responseData['name'] = dataDetail.get('tanggal')
            responseData['Sent'] = parseInt(dataDetail.get('total-sent'))+parseInt(dataDetail.get('total-no-dr'))
            responseData['Delivered'] = parseInt(dataDetail.get('total-delivered'))
            responseData['Read'] = parseInt(dataDetail.get('total-read'))
            responseData['Failed'] = parseInt(dataDetail.get('total-failed'))+parseInt(dataDetail.get('total-not-sent'))
            finalData.push(responseData)
            //
        }
        data = finalData
    }
    dispatch({ type: GetDailyMessageByStatus, data:data });
    return data
};